<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row>
              <el-col :md="10" :lg="10">
                <el-input :rows="1" placeholder="多个货号之间使用英文逗号 ',' 分隔" v-model="params.item_bns" clearable size="small">
                  <el-button slot="append" icon="el-icon-search" @click="goodsSearch"></el-button>
                </el-input>
              </el-col>
              <el-col :md="10" :lg="10">
                <el-button type="primary" size="small" icon="el-icon-circle-plus-outline" @click="showAddItemDialog">添加</el-button>
                <!-- <el-button type="success" size="small" @click="download">导入</el-button>
                <el-button type="danger" size="small" @click="download">导出</el-button> -->
              </el-col>
            </el-row>
            <el-table :data="list" style="width: 100%" v-loading="loading" element-loading-text="数据加载中">
                <el-table-column prop="id" label="ID" width="80"></el-table-column>
                <el-table-column prop="item_bn" label="商品货号" width="120"></el-table-column>
                <el-table-column prop="item_name" label="商品名称"></el-table-column>
                <el-table-column prop="created_at" label="创建时间">
                  <template slot-scope="scope">
                    {{ scope.row.created_at | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column>
                <!-- <el-table-column prop="updated_at" label="更新时间">
                  <template slot-scope="scope">
                    {{ scope.row.updated_at | datetime('yyyy-MM-dd hh:mm:ss') }}
                  </template>
                </el-table-column> -->
                <el-table-column prop="activeList" label="操作">
                  <template slot-scope="scope">
                    <el-button type="danger" size="mini" @click="delItems(scope.row.id)">删除</el-button>
                  </template>
                </el-table-column>
            </el-table>
            <div class="content-center content-top-padded">
              <el-pagination
                  background
                  layout="total, sizes, prev, pager, next"
                  @current-change="handleCurrentChange"
                  @size-change="handleSizeChange"
                  :current-page.sync="params.page"
                  :page-sizes="[20,50,100,200,500]"
                  :total="total_count"
                  :page-size="params.pageSize">
              </el-pagination>
            </div>
        </div>
        <router-view></router-view>
        <el-dialog title="添加禁售商品" width="40%" :visible.sync="addItemsDialog" :before-close="handleCancelLabelsDialog">
          <template>
            <el-form ref="form" :model="form" class="demo-ruleForm" label-width="100px">
              <el-form-item class="content-left" label="商品货号">
                <el-input placeholder="请输入商品货号" v-model="form.item_bn"></el-input>
              </el-form-item>
              <el-form-item class="content-left" label="商品名称">
                <el-input placeholder="请输入商品名称" v-model="form.item_name"></el-input>
              </el-form-item>
              <el-form-item class="content-center">
                <el-button type="primary" @click="addItems">添加</el-button>
              </el-form-item>
            </el-form>
          </template>
        </el-dialog>
    </div>
</template>
<script>
import { getDisabledItemsList, addDisabledItems, delDisabledItems } from '@/api/goods'
export default {
    data() {
      return {
        loading: false,
        addItemsDialog: false,
        params: {
          page: 1,
          pageSize: 20,
          item_bns: '',
        },
        form: {
          item_bn: '',
          item_name: '',
        },
        total_count: 0,
        list: [],
      }
    },
    methods: {
      // 显示添加禁售商品对话框
      showAddItemDialog() {
        this.addItemsDialog = true
        this.form = {
          item_bn: '',
          item_name: '',
        }
      },
      // 添加禁售商品
      addItems() {
        if (!this.form.item_bn || !this.form.item_name) {
          this.$message.error('商品货号和商品名称不能为空')
          return
        }
        addDisabledItems(this.form).then(res => {
          if (res.data.data.status === true) {
            this.$message({
              type: 'success',
              message: '添加成功'
            })
            this.addItemsDialog = false
            this.getItemsList()
          } else {
            this.$message.error({
              type: 'error',
              message: res.data.data.msg
            })
          }
        }).catch(() => {
          this.loading = false
        })
      },
      // 获取禁售商品列表
      getItemsList() {
        this.loading = true
        console.log(this.params)
        getDisabledItemsList(this.params).then(res => {
          this.loading = false
          this.list = res.data.data.list
          this.total_count = res.data.data.total_count
        })
      },
      // 删除禁售商品
      delItems(id) {
        this.$confirm('确认要删除该网络禁售商品?', '警告', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          delDisabledItems(id).then(res => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this.getItemsList()
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消'
          })
        })
      },
      // 导出禁售商品数据
      download() {
        limitedtimesaleExport(this.params).then(res => {
          if (res.data.data.status == true) {
            window.location.href = res.data.data.url
            this.$message.success('导出成功')
          } else {
            this.$message.error(res.data.msg)
          }
        })
      },
      // 搜索禁售商品
      goodsSearch() {
        this.params.page = 1
        this.getItemsList()
      },
      // 修改页面展示数量
      handleSizeChange(pageSize) {
        this.params.page = 1
        this.params.pageSize = pageSize
        this.getItemsList()
      },
      // 切换分页
      handleCurrentChange(page_num) {
        this.params.page = page_num
        this.getItemsList()
      },
      // 取消添加禁售商品对话框
      handleCancelLabelsDialog() {
        this.addItemsDialog = false
      },
    },
    mounted() {
      this.getItemsList()
    }
  }
</script>



// WEBPACK FOOTER //
// list.vue?11c5f018